
import * as React from "react"

const MOBILE_BREAKPOINT = 768;

export function useIsMobile() {
  // Initialize with the value we detected at startup
  const [isMobile, setIsMobile] = React.useState<boolean>(() => {
    if (typeof window !== 'undefined') {
      return window.innerWidth < MOBILE_BREAKPOINT;
    }
    return false;
  });

  React.useEffect(() => {
    // Check mobile status on mount and window resize
    const checkMobile = () => {
      const width = window.innerWidth;
      const newIsMobile = width < MOBILE_BREAKPOINT;
      
      if (newIsMobile !== isMobile) {
        setIsMobile(newIsMobile);
        document.documentElement.setAttribute('data-is-mobile', newIsMobile ? 'true' : 'false');
        document.documentElement.setAttribute('data-screen-width', width.toString());
      }
    };
    
    // Add media query listener
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const mqlHandler = (e: MediaQueryListEvent) => {
      const newIsMobile = e.matches;
      if (newIsMobile !== isMobile) {
        setIsMobile(newIsMobile);
      }
    };
    
    // Add event listeners
    try {
      mql.addEventListener("change", mqlHandler);
      window.addEventListener("resize", checkMobile, { passive: true });
    } catch (e) {
      // Fallback for older browsers
      mql.addListener(checkMobile);
    }
    
    // Clean up
    return () => {
      try {
        mql.removeEventListener("change", mqlHandler);
        window.removeEventListener("resize", checkMobile);
      } catch (e) {
        mql.removeListener(checkMobile);
      }
    };
  }, [isMobile]);

  return isMobile;
}
